import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingBottom: 50,
      marginTop: '15px',
    },
    cardHeader: {
      backgroundColor: Colors.secundary,
      color: Colors.tertiary,
      height: 12,
    },
    cardContent: {
      paddingRight: 250,
      paddingLeft: 250,

      [theme.breakpoints.down('sm')]: {
        width: '100%',
        paddingRight: 10,
        paddingLeft: 10,
      },
    },
    fileSelectConteiner: {
      padding: 0,
    },
    submitButton: {
      minWidth: 175,
      fontFamily: 'Texta Medium',
      backgroundColor: Colors.main,
      color: '#fff',
      border: 'none',
      '&:hover': {
        fontFamily: 'Texta Heavy',
        backgroundColor: Colors.secundary,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #fcb51d',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      height: '300px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '24px',
    },
    button: {
      backgroundColor: Colors.secundary,
      color: '#404040',
      '&:hover': {
        backgroundColor: Colors.hoverMain,
      },
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
  }),
);
